import { z } from "zod";
import { CAR_YEAR_MAX, CAR_YEAR_MIN, ORDER_SOURCES, PRODUCT_LINES, WHEEL_SIZES } from "./enums.js";
import { normalizePhone } from "./phone.js";

/** Shared validation for the New/Edit order form (apps/web) and Bot B's add-order flow. */
export const orderDraftSchema = z.object({
  clientName: z.string().trim().min(1, "Вкажіть ім'я клієнта"),
  phone: z
    .string()
    .trim()
    .min(1, "Вкажіть телефон")
    .transform((v) => normalizePhone(v)),
  productLine: z.enum(PRODUCT_LINES),
  // Required for the wheels line only; steering-wheel orders skip it (see AGENTS.md §6.2).
  sizeSpec: z.enum(WHEEL_SIZES).optional().nullable(),
  carBrand: z.string().trim().optional().nullable(),
  carYear: z
    .number()
    .int()
    .min(CAR_YEAR_MIN)
    .max(CAR_YEAR_MAX)
    .optional()
    .nullable(),
  source: z.enum(ORDER_SOURCES),
  purchasePrice: z.number().nonnegative().optional().nullable(),
  amount: z.number().nonnegative().optional().nullable(),
  prepayment: z.number().nonnegative().optional().nullable(),
  extraSales: z.number().nonnegative().optional().nullable(),
  deliveryCost: z.number().nonnegative().optional().nullable(),
  notes: z.string().optional().nullable(),
});

export type OrderDraft = z.infer<typeof orderDraftSchema>;

/**
 * Structured extraction target for Bot B's voice pipeline (Whisper -> Claude, AGENTS.md
 * §10). All fields optional/nullable — Claude must not hallucinate values it didn't hear.
 */
export const voiceOrderExtractionSchema = z.object({
  clientName: z.string().nullable(),
  phone: z.string().nullable(),
  sizeSpec: z.enum(WHEEL_SIZES).nullable(),
  carBrand: z.string().nullable(),
  carYear: z.number().int().nullable(),
  amount: z.number().nullable(),
  note: z.string().nullable(),
});

export type VoiceOrderExtraction = z.infer<typeof voiceOrderExtractionSchema>;
